module.exports = __webpack_public_path__ + "img/pencil.3806ed53.svg";